export enum OnboardingStatuses {
  Unknown,
  InProcess,
  Ended,
}
